import { render, staticRenderFns } from "./StockManagementDetail.vue?vue&type=template&id=169588aa&"
import script from "./StockManagementDetail.vue?vue&type=script&lang=js&"
export * from "./StockManagementDetail.vue?vue&type=script&lang=js&"
import style0 from "./StockManagementDetail.vue?vue&type=style&index=0&id=169588aa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports